import { HEADER_MOTION_CATALOG } from '@shared/core/website/headerMotion/headerMotion.catalog';
import type { HeaderMotionTypeId } from '@shared/core/website/headerMotion/headerMotion.types';

import type { HeaderMotionTypeDef } from './headerMotion.registry.types';
import { LazyBloom } from './types/bloom/Bloom.lazy';
import { parseBloomOptions } from './types/bloom/bloom.options';
import { LazyCinematic } from './types/cinematic/Cinematic.lazy';
import { parseCinematicOptions } from './types/cinematic/cinematic.options';
import { LazyCurtain } from './types/curtain/Curtain.lazy';
import { parseCurtainOptions } from './types/curtain/curtain.options';
import { LazyPolaroid } from './types/polaroid/Polaroid.lazy';
import { parsePolaroidOptions } from './types/polaroid/polaroid.options';
import { LazyShowcase } from './types/showcase/Showcase.lazy';
import { parseShowcaseOptions } from './types/showcase/showcase.options';
import { LazyWildflowers } from './types/wildflowers/Wildflowers.lazy';
import { parseWildflowersOptions } from './types/wildflowers/wildflowers.options';

/**
 * Every Motion type the guest header can render, keyed by its saved `type` id.
 *
 * Each entry spreads the shared `HEADER_MOTION_CATALOG` entry (id, supported media, defaults — also
 * read by the admin designer) and adds the guest-only runtime: the options parser and the lazy
 * `Component`, so a type's code is fetched only when a header actually enables it. Adding a type
 * means adding an id to `HeaderMotionTypeId`, a catalog entry, and an entry here.
 */
export const motionRegistry: Readonly<Record<HeaderMotionTypeId, HeaderMotionTypeDef>> = {
  cinematic: {
    ...HEADER_MOTION_CATALOG.cinematic,
    parseOptions: parseCinematicOptions,
    Component: LazyCinematic,
  },
  bloom: {
    ...HEADER_MOTION_CATALOG.bloom,
    parseOptions: parseBloomOptions,
    Component: LazyBloom,
  },
  wildflowers: {
    ...HEADER_MOTION_CATALOG.wildflowers,
    parseOptions: parseWildflowersOptions,
    Component: LazyWildflowers,
  },
  showcase: {
    ...HEADER_MOTION_CATALOG.showcase,
    parseOptions: parseShowcaseOptions,
    Component: LazyShowcase,
  },
  polaroid: {
    ...HEADER_MOTION_CATALOG.polaroid,
    parseOptions: parsePolaroidOptions,
    Component: LazyPolaroid,
  },
  curtain: {
    ...HEADER_MOTION_CATALOG.curtain,
    parseOptions: parseCurtainOptions,
    Component: LazyCurtain,
  },
};
